/**
 * közös cuccok, és olyan libek, amik nagyon sok helyen, például mindenhol használatban vannak
 * @author sarkiroka on 2017.10.11.
 */
// Vue libs
import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import {mediaQueries} from '../common/mediaQuery/mediaQuery';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';
import 'picturefill';
import VueScrollTo from 'vue-scrollto';
import RamaAnalytics from '../common/analytics/rama-analytics';
import PriceFilter from '../common/price-filter/price-filter';
import EventBus from '../common/event-bus/event-bus';
import Cookies from 'js-cookie';

import componentLoader from '../common/component-loader/component-loader.js';

// Vue plugins
Vue.use(Vuex);
Vue.use(Vuelidate);
// most a TARR kft kulcsa van beállítva, de hozzá van adva a hello@shiwaforce.com címhez is a kulcs
Vue.use(VueGoogleMaps, {
	load: {
		key: window.context.googleMapsApiKey,
		libraries: 'places'
	}
});
Vue.use(VueGeolocation);
Vue.use(mediaQueries);
Vue.use(VueScrollTo);

window.axios = axios;

// axios interceptors
import uuidv4 from 'uuid/v4';
let sessionId = Cookies.get('sa-cookie');
if (!sessionId || sessionId == 'undefined' || sessionId == 'null') {
	sessionId = uuidv4();
	Cookies.set('sa-cookie', sessionId);
}
window.sessionId = sessionId;

axios.interceptors.request.use(function (config) {
	config.headers.sessionId = window.sessionId;
	return config;
}, function (error) {
	return Promise.reject(error);
});

window.EventBus = EventBus;

// user components

// global Vue directives
Vue.directive('ramalytics', RamaAnalytics);
Vue.directive('component-loader', componentLoader);

// global Vue filters
Vue.filter('price', PriceFilter);



// WEBPACK FOOTER //
// ../source/build-entry/libs.js